import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getCmsApiPageHomePageMeta({ content }: Props) {
  const { subsite } = content;

  const hasHomePage = Boolean(subsite.homePage);
  const subsiteHasHomePage = hasHomePage || Boolean(subsite.homePage);
  const homePageUrl = subsite.homePage ? subsite.homePage.url : '';

  return { hasHomePage, subsiteHasHomePage, homePageUrl };
}
